import { useAtomValue } from 'jotai';
import { organizationDataAtom } from '@/store';
import { ComponentType } from 'react';

/**
 * Higher-order component that wraps a page component with org-keyed remounting.
 * When the organization changes, the wrapped component is fully unmounted and remounted,
 * resetting all local useState hooks and preventing data leakage between organizations.
 */
export function withOrgReset<P extends object>(Component: ComponentType<P>) {
  return function OrgResetWrapper(props: P) {
    const organizationData = useAtomValue(organizationDataAtom);
    return <Component {...props} key={organizationData?.id ?? 'no-org'} />;
  };
}
